<div class="orcaa-wrapper">

    <!-- HEADER -->
    <h2 class="fw-bold gradient-text">EngageNet</h2>
    <p class="text-muted mb-4">
      Community Engagement & Operations Platform. Better communication • Faster service • Digital voting • Real insights.
    </p>

    <!-- TOP METRIC CARDS -->
    <div class="row g-3 mb-3">

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-primary">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Communication</span>
                        <i class="fa-solid fa-comments text-primary"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Better</div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-success">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Service</span>
                        <i class="fa-solid fa-refresh text-success"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Faster</div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Voting</span>
                        <i class="fa-solid fa-line-chart gradient-text"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Digital</div>
                </div>
            </div>
        </div>

       <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-warning">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Insights</span>
                        <i class="fa-solid fa-suitcase text-warning"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Clear</div>
                </div>
            </div>
        </div>

    </div>

    <!-- FEATURE CARDS (PERFECT 2×2 GRID) -->
    <div class="row g-4">

      <!-- CARD 1 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-table gradient-text"></i>
            </div>
            <h5 class="fw-bold">Create & Manage Community Events</h5>
          </div>

          <p class="text-muted feature-body">
            Schedule events, track attendees, send reminders, and manage updates — all in one place.
          </p>

          <button class="btn upload-button w-100" @click="launch_workspace('events')">
            <i class="bi bi-upload me-2"></i>Manage Events
          </button>

        </div>
      </div>

      <!-- CARD 2 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-commenting gradient-text"></i>
            </div>
            <h5 class="fw-bold">Community News Feed</h5>
          </div>

          <div class="feature-body">
            <p class="text-muted">
              Share announcements, alerts, updates, and multimedia posts.
              Keep your community informed instantly.
            </p>

          </div>

          <button class="btn upload-button w-100 mt-3" @click="launch_workspace('community')">
            Open Feed
          </button>

        </div>
      </div>

      <!-- CARD 3 -->
      <div class="col-md-6 d-none">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-book gradient-text"></i>
            </div>
            <h5 class="fw-bold">Submit & Track Service Requests</h5>
          </div>

          <p class="text-muted feature-body">
            Log issues, track progress, receive status updates, and streamline community support.
          </p>

          <button class="btn upload-button w-100">
            <i class="bi bi-upload me-2"></i>Submit Request
          </button>

        </div>
      </div>

      <!-- CARD 4 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-bar-chart gradient-text"></i>
            </div>
            <h5 class="fw-bold">Share Documents & Notices</h5>
          </div>

          <p class="text-muted feature-body">
            Upload and distribute important notices, minutes, reports, and documents to your community.
          </p>

          <button class="btn upload-button w-100">
            <i class="bi bi-upload me-2"></i>Share Document
          </button>

        </div>
      </div>

      <!-- CARD 5 -->
      <div class="col-md-6 d-none">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-upload gradient-text"></i>
            </div>
            <h5 class="fw-bold">Upload CSV → Auto-Dashboard Creation</h5>
          </div>

          <p class="text-muted feature-body">
            Upload learner data, marks, or attendance.
            AI generates skills heatmaps and trend insights instantly.
          </p>

          <button class="btn upload-button w-100">
            <i class="bi bi-upload me-2"></i>Upload File
          </button>

        </div>
      </div>

      <!-- CARD 6 -->
      <div class="col-md-6 d-none">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-user gradient-text"></i>
            </div>
            <h5 class="fw-bold">Personalised Learning Path from One Sentence</h5>
          </div>

          <div class="feature-body">
            <p class="text-muted">
              Describe your learning goal.
              AI creates a complete learning path with modules and time estimates.
            </p>

          </div>

          <button class="btn upload-button w-100 mt-3">
            Generate AI Insights
          </button>

        </div>
      </div>

    </div>

  </div>